import { useRef, useState, useEffect, useCallback, useContext } from "react";
import { Message_data } from "../context/context";
// import { parseBlob } from "music-metadata-browser";
import { auth, db, db2, storage } from "../firebase-config";
import {
  collection,
  query,
  doc,
  setDoc,
  getDocs,
  addDoc,
  where,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Player from "../components/AudioMusicPlayer/Player";
import axios from "axios";
import X2JS from "x2js";

export const NLMFileReader = ({ handleFile, user, playlistId, currentPlaylist }) => {
  const { message, setMessage } = useContext(Message_data);
  const [jukebox, setJukebox] = useState([]);
  const [trackList, setTrackList] = useState([]);
  const [NMLFile, setNMLFile] = useState("");
  const [showLoadingAni, setShowLoadingAni] = useState(true);
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const blobUrlsRef = useRef([]); // Track blob URLs for cleanup

  // Cleanup blob URLs on component unmount
  // useEffect(() => {
  //   return () => {
  //     blobUrlsRef.current.forEach(url => {
  //       URL.revokeObjectURL(url);
  //     });
  //     blobUrlsRef.current = [];
  //   };
  // }, []);

  useEffect(() => {
    const playerControlData = async () => {
      if (message) {
        const data = JSON.parse(message);
        if (data.loadingAni) {
          const loadingAni = JSON.parse(data.loadingAni);
          // console.log("loadingAni", loadingAni);
          setTimeout(() => {
            setShowLoadingAni(loadingAni);
          }, 2000);
        }
        //
        if (data.loadedPlaylist) {
          // acknowledge that the playlist has reloaded
          setShowLoadingAni(false)
        }
      }
    };
    playerControlData();
  }, [message]);

  let songs = document.getElementById("songs");

  // Create a reference to the hidden file input element
  const hiddenFileInput = useRef(null);

  // Programatically click the hidden file input element
  // when the Button component is clicked
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };


  // Call a function (passed as a prop from the parent component)
  // to handle the user-selected file
  const handleChange = async (e) => {
    e.preventDefault();

    let parsed2;
    let nmlgenre = {};
    const playlist = [];
    
    // First, process NML files to get genre information
    for (let i = 0; i < songs.files.length; i++) {
      if (songs.files.item(i).name.split(".")[1] === "nml") {
        setNMLFile(songs.files.item(i).name);
        const reader = new FileReader();

        // eslint-disable-next-line no-loop-func
        reader.onload = async (e) => {
          const file = e.target.result;

          let x2js = new X2JS();
          parsed2 = x2js.xml2js(file.toString()).NML.COLLECTION.ENTRY;
          parsed2.forEach((nml, i) => {
            nmlgenre[nml.LOCATION._FILE] = nml.INFO._GENRE;
          });
        };

        reader.readAsText(songs.files.item(i));
      }
    }

    setShowLoadingAni(true);

    // Clean up previous blob URLs before creating new ones
    blobUrlsRef.current.forEach(url => {
      URL.revokeObjectURL(url);
    });
    blobUrlsRef.current = [];

    // Array to accumulate all processed tracks
    const allProcessedTracks = [];

    // Process audio files
    for (let i = 0; i < songs.files.length; i++) {
      if (songs.files.item(i).name.split(".")[1] !== "nml") {
        let url = URL.createObjectURL(songs.files.item(i));
        blobUrlsRef.current.push(url); // Track the blob URL


        // let picture = songs.files.item(i).common.picture[0];
        // let blob = new Blob([picture.data], { type: picture.format });
        // const audioMetadata = await parseBlob(songs.files.item(i));
        // let coverUrl = URL.createObjectURL(blob);
        // console.log('audioMetadata', audioMetadata);
        // setCoverArt({
        //   url: coverUrl,
        //   format: picture.format,
        //   size: picture.data.length
        // });



        console.log('songs.files.item(i).name', songs.files.item(i).name)
        // let artist = songs.files.item(i).name.split(".")[0].split(" - ")[0];
        // let track = songs.files.item(i).name.split(".")[0].split(" - ")[1];
        let filename = songs.files.item(i).name;

        // check if this track is already in the firestore 'tracks' collection
        // it comes with a an id and probably already got cover art so skip getting another cover art url
        // might even have a youtube id who knows?
        // should search for the filename specifically
        //  if found insert it into trackObj otherwise insert this new stuff

        // eslint-disable-next-line no-loop-func

        // search for filename in 'tracks' collection
        // if filename found this means the track already exists
        // update the record in 'tracks' and also the corresponding record in 'playlists'
        // if its not found in 'tracks' create a new record and also update the corresponding
        // playlists collection with this new record
        // use promises

        // Process the file
        let processFile = new Promise(function (resolve, reject) {
          resolve("Promise resolved");
        });

        processFile
          // eslint-disable-next-line no-loop-func
          .then(async () => {
            const searchObj = await searchFilename(filename);
            if (searchObj) {
              // ebz++;
              // Update the URL for existing track
              searchObj.url = url;
              
              // Only extract and upload cover art if it doesn't exist
              if (!searchObj.coverart || searchObj.coverart === "") {
                const metadata = await extractAndUploadCoverArt(songs.files.item(i), filename);
                if (metadata && metadata.downloadURL) {
                  searchObj.coverart = metadata.downloadURL;
                  searchObj.genre = metadata.genre || searchObj.genre || "none";
                  searchObj.artist = metadata.artist || searchObj.artist;
                  searchObj.track = metadata.title || searchObj.track;
                }
              }
              
              // Update the track in the database with new URL (and coverart if it was added)
              await setDoc(doc(db, "tracks", searchObj.id), searchObj);
              
              return searchObj;
            } else {
              // New track - extract metadata and upload cover art
              const metadata = await extractAndUploadCoverArt(songs.files.item(i), filename);
              console.log('mp3 metadata', metadata);
              let trackObj = {
                artist: metadata?.artist || "",
                track: metadata?.title || "",
                url: url,
                filename: filename,
                genre: metadata?.genre || "nonex",   // || nmlgenre[`${filename}`] 
                nmlgenre: nmlgenre[`${filename}`] || "",
                coverart: metadata?.downloadURL || "",
                youTubeId: "",
              };
              
              // Save this new track
              const newTrack = await saveTrack(trackObj);
              trackObj.id = newTrack.id;
              // await timeout(6500);
              return trackObj;
            }
          })
          // eslint-disable-next-line no-loop-func
          .then((item) => {
            playlist.push(item);
            
            // Add to accumulated tracks array
            allProcessedTracks.push(item);

            if (i === songs.files.length - 1) {
              // Process all playlist updates after all files are processed
              setTimeout(async () => {
                // Batch update all tracks in the playlist
                const updatePromises = allProcessedTracks.map((track, index) => 
                  setDoc(
                    doc(db, "playlists", playlistId.id, "tracks", track.id),
                    {
                      ...track,
                      genre: track.genre || "",
                      ordinal: index,
                    }
                  )
                );
                
                try {
                  await Promise.all(updatePromises);
                  console.log(`Successfully updated ${allProcessedTracks.length} tracks in playlist`);
                  setShowLoadingAni(false);
                  
                  // Send message to notify playlist has been loaded
                  const loadedPlaylist = { loadedPlaylist: true };
                  setMessage(JSON.stringify(loadedPlaylist));
                  
                  forceUpdate();
                } catch (error) {
                  console.error("Error updating playlist:", error);
                  setShowLoadingAni(false);
                }
              }, 500); // Further reduced delay
            }
          })
          .catch((error) => {
            console.error("Error processing file:", filename, error);
          });
      }
      // await timeout(2000); 
    }
  };

  const saveTrack = async (trackObj) => {
    const requestSongRef5 = collection(db, "tracks");
    try {
      const newprod = await addDoc(requestSongRef5, trackObj);
      return newprod;
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };


  const searchFilename = async (filename) => {
    let fileList;

    try {
      const urlsRef = collection(db, "tracks");
      const q = query(urlsRef, where("filename", "==", filename));
      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((docSnap) => {
        fileList = {
          id: docSnap.id,
          track: docSnap.data().track,
          genre: docSnap.data().genre,
          artist: docSnap.data().artist,
          coverart: docSnap.data().coverart,
          // coverart2: docSnap.data().coverart2,
          filename: docSnap.data().filename,
          youTubeId: docSnap.data().youTubeId,
        };
      });

      return fileList; // Generate the returned object in the forEach loop, see link below
    } catch (e) {
      console.error("Error querying document: ", e);
      return e.response;
    }
  };


  // const getCoverart = async (artisttrack) => {
  //   // first search for this track in the firehost database
  //   // if its there send back the track id it doesn't have acoverar then look for it below and send that back in the te obj
  //   try {
  //     // get covert with query
  //     // alt url  :   https://getcoverartmuuz-sflat6mtua-uc.a.run.app
  //     const coverart = await axios.get(
  //       "https://getcoverart-n44tsg7wia-uc.a.run.app/?coverart=" + artisttrack
  //     );

  //     return await coverart.data.coverart.coverart;
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };


  const extractAndUploadCoverArt = async (file, filename) => {
    // await timeout(6500);
    return new Promise((resolve) => {
      // Check if jsmediatags is available
      if (typeof window.jsmediatags === 'undefined') {
        console.warn('jsmediatags library not loaded');
        resolve({ downloadURL: null, artist: null, genre: null, title: null });
        return;
      }

      window.jsmediatags.read(file, {
        onSuccess: async function(tag) {
          try {
            const tags = tag.tags;
            // console.log('tags', tags);
            
            const metadata = {
              downloadURL: null,
              artist: tags?.artist || null,
              genre: tags?.genre || null,
              title: tags?.title || null,
            };
            
            // Check if picture/cover art exists
            if (tags?.picture) {
              const picture = tags.picture;
              const data = picture.data;
              const format = picture.format;
              
              // Convert array to Uint8Array
              const byteArray = new Uint8Array(data);
              
              // Create blob from the byte array
              const blob = new Blob([byteArray], { type: format });
              
              // Create a unique filename for the cover art
              const coverArtFilename = `coverart/${filename.replace(/\.[^/.]+$/, "")}.jpg`;
              
              // Create a storage reference
              const storageRef = ref(storage, coverArtFilename);
              
              try {
                // Upload the blob
                const uploadResult = await uploadBytes(storageRef, blob);
                
                // Get the download URL
                const downloadURL = await getDownloadURL(uploadResult.ref);
                metadata.downloadURL = downloadURL;
              } catch (uploadError) {
                console.error('Error uploading cover art:', uploadError);
              }
            }
            
            resolve(metadata);
          } catch (error) {
            console.error('Error processing tags:', error);
            resolve({ downloadURL: null, artist: null, genre: null, title: null });
          }
        },
        onError: function(error) {
          console.error('Error reading tags from file:', filename, error);
          resolve({ downloadURL: null, artist: null, genre: null, title: null });
        }
      });
    });
  };

  function timeout(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  return (
    <>
    <div className="flex flex-row">
    <button
        className="flex items-center justify-center  bg-red-500 hover:bg-red-600 rounded-xl text-white px-4 py-1  w-100 h-12 mt-4 mr-2 ml-2"
        onClick={handleClick}
      >
        <span>
          <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
            <title>Upload-3</title>
            <g
              id="Page-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g id="Upload-3">
                <rect
                  id="Rectangle"
                  fill-rule="nonzero"
                  x="0"
                  y="0"
                  width="24"
                  height="24"
                ></rect>
                <line
                  x1="12"
                  y1="5"
                  x2="12"
                  y2="15"
                  id="Path"
                  stroke="#FFFFFF"
                  stroke-width="2"
                  stroke-linecap="round"
                ></line>
                <line
                  x1="19"
                  y1="20"
                  x2="5"
                  y2="20"
                  id="Path"
                  stroke="#FFFFFF"
                  stroke-width="2"
                  stroke-linecap="round"
                ></line>
                <path
                  d="M7,9 L11.2929,4.70711 C11.6834,4.31658 12.3166,4.31658 12.7071,4.70711 L17,9"
                  id="Path"
                  stroke="#FFFFFF"
                  stroke-width="2"
                  stroke-linecap="round"
                ></path>
              </g>
            </g>
          </svg>
        </span>
        <span className="text-sm font-black">UPLOAD MUUZBOX CRATE</span>
      </button>
    </div>
      <input
        type="file"
        onChange={(e) => handleChange(e)}
        ref={hiddenFileInput}
        style={{ display: "none" }} // Make the file input element invisible
        id="songs"
        name="fileList"
        webkitdirectory=""
      />
      {trackList.length > 0 && (
        <div className="bg-black">
          <Player jukebox={jukebox} trackList={trackList} />
        </div>
      )}
      {showLoadingAni && (
        <div className="bg-white divide-y divide-gray-100 rounded-lg shadow-lg w-44 dark:bg-gray-700 muuz-delete-confirm-panel mt-24 text-black">
          <div className="flex justify-between items-center text-black">
            <div></div>
            <div></div>
            <div></div>
          </div>
          <div class="muuzbox-loader-logo-sm2 fadeIn" style={{ top: "200px" }}>
            <img src="img/muuzbox-logo.png" alt="Muuzbox logo" />
            <div class="muuzbox-loader-blob"></div>
          </div>
        </div>
      )}
    </>
  );
};
